/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import 'alpinejs'
import I18n from '../vendor/I18n';
import 'jquery-ui/ui/widgets/progressbar.js';
import 'jquery-ui/ui/widgets/datepicker.js';

window.I18n = I18n;
window.$ = window.jQuery = require('jquery');
window.Swal = require('sweetalert2');

require('../bootstrap');
require('../plugins');

$(function () {
	const csrftoken = document.querySelector('meta[name="csrf-token"]').getAttribute('Content'),
		translator = new I18n;

	if ('serviceWorker' in navigator) {
		window.addEventListener('load', function () {
			navigator.serviceWorker.register('/sw.js?myChanel=' + myChanel).then(r => console.log(r));
		});
	}

	/*if (!('Notification' in window)) {
		Swal.fire(translator.trans('script.This browser does not support notifications.'));
	}*/

	function urlBase64ToUint8Array(base64String) {
		const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
		const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

		const rawData = window.atob(base64);
		const outputArray = new Uint8Array(rawData.length);

		for (let i = 0; i < rawData.length; ++i) {
			outputArray[i] = rawData.charCodeAt(i);
		}
		return outputArray;
	}

	function enablePushNotifications() {
		navigator.serviceWorker.ready.then(registration => {
			registration.pushManager.getSubscription().then(subscription => {
				if (subscription) {
					return subscription;
				}

				const serverKey = urlBase64ToUint8Array(process.env.MIX_VAPID_PUBLIC_KEY);

				return registration.pushManager.subscribe({
					userVisibleOnly: true,
					applicationServerKey: serverKey
				});
			}).then(subscription => {
				if (!subscription) {
					Swal.fire(translator.trans('script.An error occurred while subscribing to push.'));
					return;
				}
				subscribe(subscription);
			});
		});
	}

	function disablePushNotifications() {
		navigator.serviceWorker.ready.then(registration => {
			registration.pushManager.getSubscription().then(subscription => {
				if (!subscription) {
					Swal.fire(translator.trans('script.Subscription not found'));
					return;
				}

				subscription.unsubscribe().then(() => {
					fetch('/notification/unsubscribe', {
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							'X-CSRF-TOKEN': csrftoken
						},
						body: JSON.stringify({
							endpoint: subscription.endpoint
						})
					})
						.then(response => response.json())
						.then(data => {
							Swal.fire(data['message']);
						})
						.catch((error) => {
							console.error('Error:', error);
						});
				})
			});
		});
	}

	function subscribe(sub) {
		const key = sub.getKey('p256dh')
		const token = sub.getKey('auth')
		const contentEncoding = (PushManager.supportedContentEncodings || ['aesgcm'])[0]

		const data = {
			endpoint: sub.endpoint,
			public_key: key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
			auth_token: token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null,
			encoding: contentEncoding,
		};

		fetch('/notification/subscribe', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'X-CSRF-TOKEN': csrftoken
			},
			body: JSON.stringify(data)
		})
			.then(response => response.json())
			.then(data => {
				console.log('Success:', data);

				const xhttp = new XMLHttpRequest();
				xhttp.open("GET", window.location.origin + '/notification/welcome', true);
				xhttp.send();
			})
			.catch((error) => {
				console.error('Error:', error);
			});
	}

	let enablePush = document.getElementById('enable-push');
	let disablePush = document.getElementById('disable-push');

	if (enablePush) {
		enablePush.addEventListener('click', function () {
			enablePushNotifications();
		});
	}

	if (disablePush) {
		disablePush.addEventListener('click', function () {
			disablePushNotifications();
		});
	}
});